import { ui } from '@platform/ui';

let count = 0;

export function loadingRule(): boolean {
  return true;
}

export function loadingReqInterceptor<T extends NetRequest>(config: T): NetRequest {
  if (config.useLoading) {
    count += 1;
    (ui.loading() as any).show();
  }
  return config;
}

export function loadingResInterceptor<T>(res: NetResult<T>, req?: NetRequest): NetResult<T> {
  if (req?.useLoading) {
    count -= 1;
    if (count === 0) (ui.loading() as any).hide();
  }
  return res;
}
